export var CollectorSetupResultStatus;
(function (CollectorSetupResultStatus) {
    CollectorSetupResultStatus["success"] = "success";
    CollectorSetupResultStatus["not_supported"] = "not_supported";
    CollectorSetupResultStatus["permission_denied"] = "permission_denied";
    CollectorSetupResultStatus["device_not_found"] = "device_not_found";
    CollectorSetupResultStatus["device_in_use"] = "device_in_use";
})(CollectorSetupResultStatus || (CollectorSetupResultStatus = {}));
